// import "@fortawesome/fontawesome-free/css/all.css";
import "./fontawesome/fontawesome-pro/css/all.min.css";
import pt from "../locale/pt.ts";
import en from "../locale/en.ts";
import es from "../locale/es.ts";
import ca from "../locale/ca.ts";
import colors from "vuetify/util/colors";
import { createVuetify } from "vuetify";
import * as vuetifycomponents from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, fa } from "vuetify/iconsets/fa";
import "vuetify/styles";
import { VDateInput } from "vuetify/labs/VDateInput";

const lightTheme = {
  dark: false,
  colors: {
    primary: process.env.VUE_APP_VUETIFY_PRIMARY,
    secondary: process.env.VUE_APP_VUETIFY_SECONDARY, //colors.orange.lighten2,
    accent: process.env.VUE_APP_VUETIFY_ACCENT,
    error: process.env.VUE_APP_VUETIFY_ERROR, //colors.red.darken2,
    warning: process.env.VUE_APP_VUETIFY_WARNING, //colors.yellow.darken2,
    info: process.env.VUE_APP_VUETIFY_INFO, //colors.blue.darken2,
    success: process.env.VUE_APP_VUETIFY_SUCCESS, //colors.green.darken2s
    active: "#FF0000",
    blue: "#2196F3",
    orange: "#ffb74d",
  },
};

const darkTheme = {
  dark: true,
  colors: {
    primary: colors.blue.darken2,
    accent: colors.grey.darken3,
    secondary: colors.amber.darken3,
    info: colors.teal.lighten1,
    warning: colors.amber.base,
    error: colors.deepOrange.accent4,
    success: colors.green.accent3,
  },
};

const vuetify = createVuetify({
  locale: {
    current: "pt",
    fallback: "en",
    messages: { pt, en, ca, es },
    rtl: {
      customLocale: true,
    },
  },
  components: {
    VDateInput,
    vuetifycomponents,
  },
  directives,
  theme: {
    //options: {
    //  customProperties: true,
    //},
    defaultTheme: "lightTheme",
    themes: {
      lightTheme,
      darkTheme,
    },
  },
  icons: {
    defaultSet: "fa",
    aliases,
    sets: {
      fa,
    },
  },
  font: {
    family: "Cairo",
  },
});
export { vuetify };
